import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoHellosign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 168 48"
    {...props}
  >
    <g clipPath="url(#Logo_Hellosign_svg__a)">
      <path
        fill="#00B3E6"
        fillRule="evenodd"
        d="M4.662 38.102v-4.046h18.21v4.046zM19.004 17.87H8.528l5.239 7.25zm7.914-4.047-13.151 18.21L.615 13.822z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M42.968 34.057v-6.495H36.74v6.495h-3.755V17.87h3.755v6.335h6.228v-6.338h3.755v16.186zM51.461 34.057V17.87h10.257v3.442h-6.502v2.893h5.92v3.27h-5.92v3.157h6.502v3.425zM66.191 34.057V17.87h3.754v12.766h6.494v3.424zM79.59 34.057V17.87h3.76v12.766h6.494v3.424zM100.436 34.322c-5.015 0-8.217-3.6-8.217-8.35s3.358-8.372 8.372-8.372 8.216 3.602 8.216 8.372-3.379 8.35-8.371 8.35m.062-13.363c-2.561 0-4.284 2.098-4.284 5.013s1.723 5.014 4.284 5.014 4.286-2.12 4.286-5.014c0-2.893-1.719-5.013-4.286-5.013M116.921 34.322c-1.833 0-4.047-.729-5.455-1.658l1.037-3.4c1.304.949 3.005 1.567 4.529 1.567 1.326 0 1.833-.618 1.833-1.413 0-.843-.42-1.414-2.893-2.407-2.85-1.149-3.84-2.806-3.84-4.75 0-2.36 1.921-4.66 5.698-4.66 1.767 0 3.58.618 4.529 1.259l-.953 3.357c-.929-.64-2.43-1.325-3.579-1.325-1.37 0-1.921.64-1.921 1.303 0 1.06.816 1.415 2.85 2.275 3.024 1.281 3.93 2.74 3.93 4.815 0 2.585-1.877 5.037-5.765 5.037M126.712 34.057V17.87h3.755v16.187zM149.187 24.957v7.73a11.7 11.7 0 0 1-6.141 1.635c-4.748 0-8.503-3.401-8.503-8.35s3.798-8.372 8.702-8.372c2.121 0 3.82.553 5.432 1.393l-1.568 3.025a7.87 7.87 0 0 0-3.615-.905c-3.225 0-4.947 2.01-4.947 4.859 0 3.092 2.076 5.014 4.721 5.014 1.192 0 1.789-.133 2.386-.441v-2.386h-3.249v-3.204zM167.019 34.366l-9.763-8.768v8.459h-3.755V17.646l.506-.09 9.631 8.703v-8.392h3.755V34.3z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Hellosign_svg__a">
        <path
          fill="#fff"
          d="M.615 0h167v48h-167z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoHellosign;
